import { Component, EventEmitter, Input, Output } from "@angular/core";
import { OverlayPanel } from "primeng/overlaypanel";

export interface DropdownButtonOption {
    label: string;
    value: any;
}

@Component({
    selector: "m-dropdown-button",
    template: `
        <div class="buttons-panel text-center">
            <p-overlayPanel #op [showTransitionOptions]="'225ms'" [hideTransitionOptions]="'195ms'">
                <div class="options-list">
                    <div
                        *ngFor="let option of options"
                        class="option-item"
                        (click)="selectOption(option, op)"
                        (touchend)="onOptionTouchEnd($event, option, op)">
                        {{option.label}}
                    </div>
                </div>
            </p-overlayPanel>

            <button
                pButton
                type="button"
                [label]="buttonLabel"
                [disabled]="disabled"
                (click)="onButtonClick($event, op)"
                (touchend)="onButtonTouchEnd($event)"
                class="p-button-primary buttons-panel-margin-auto">
            </button>
        </div>
    `,
    styles: [`
        .buttons-panel-margin-auto {
            margin: 0 auto;
        }

        ::ng-deep .p-overlaypanel {
            .p-overlaypanel-content {
                padding: 0;
            }
        }

        ::ng-deep .options-list {
            min-width: 120px;
            background: white;
        }

        ::ng-deep .p-overlaypanel:before,
        ::ng-deep .p-overlaypanel:after {
            content: none;
        }

        ::ng-deep .option-item {
            padding: 0.5rem 1.0rem;
            cursor: pointer;
            touch-action: manipulation;
            transition: background-color 0.2s;
            text-align: center;
            color: #495057;
            font-size: 1rem;
            line-height: 1.5;
            user-select: none;

            @media (hover: hover) and (pointer: fine) {
                &:hover {
                    background-color: #e2e8f0;
                }
            }

            &:active {
                background-color: #e9ecef;
            }
        }

        ::ng-deep .p-overlaypanel:before,
        ::ng-deep .p-overlaypanel:after {
            border-width: 8px;
        }

        ::ng-deep .p-overlaypanel {
            border-radius: 6px;
            box-shadow: 0 2px 4px -1px rgba(0, 0, 0, .2), 0 4px 5px 0 rgba(0, 0, 0, .14), 0 1px 10px 0 rgba(0, 0, 0, .12);
        }

        :host ::ng-deep .p-button {
            touch-action: manipulation;
        }
    `]
})
export class DropdownButtonComponent {
    @Input() options: DropdownButtonOption[] = [];
    @Input() disabled: boolean = false;
    @Input() buttonLabel: string;
    @Output() readonly optionSelected = new EventEmitter<any>();

    private optionHandled = false;

    onButtonClick(event: Event, op: OverlayPanel) {
        event.stopPropagation();
        op.toggle(event);
    }

    onButtonTouchEnd(event: TouchEvent) {
        if (this.disabled) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        (event.currentTarget as HTMLElement).click();
    }

    onOptionTouchEnd(event: TouchEvent, option: DropdownButtonOption, op: OverlayPanel) {
        event.preventDefault();
        event.stopPropagation();
        this.selectOption(option, op);
    }

    selectOption(option: DropdownButtonOption, op: OverlayPanel) {
        if (this.optionHandled) {
            return;
        }

        this.optionHandled = true;
        this.optionSelected.emit(option.value);
        op.hide();
        setTimeout(() => this.optionHandled = false, 300);
    }
}
